module.exports = __webpack_public_path__ + "img/welcome-mobile.8ebb76ce.png";